<app-loader [loading]="isLoading || service.isLoading || ticketTypeService.typesLoading" [overlay]="true"></app-loader>
<ng-container *ngIf="service.ticketEventMap?.length">
  <table class="report-table bottom-spacer" *ngIf="!utilService.isMobile">
    <thead>
      <tr>
        <th class="min-width valign-middle" *ngIf="collapsible">
          <button mat-button class="input-button icon-button small" (click)="toggleCollapseAll()">
            <mat-icon class="svg-icon" [svgIcon]="areAllCollapsed ? 'accordion_right' : 'accordion_down'"></mat-icon>
          </button>
        </th>
        <th class="min-width align-center valign-middle" *ngIf="canSelect">
          <mat-checkbox [checked]="areAllTicketsSelected()" [indeterminate]="areAllTicketsSelected(ChildSelectionState.SOME)"
                        (change)="toggleAllTickets($event)"></mat-checkbox>
        </th>
        <th [colSpan]="3">
          {{ 'general.api_cart_table_event_title' | translate }}
          <br><small class="subtitle">{{ 'general.api_cart_table_event_venue' | translate }}</small>
          <br><small class="subtitle">{{ 'general.api_cart_table_event_date' | translate }}</small>
        </th>
        <th class="align-right" *ngIf="service.isSelfService && hasAnyPromoCode">
          <ng-container>{{ 'general.api_cart_table_event_promocode' | translate }}</ng-container>
        </th>
        <ng-container *ngIf="service.cartType !== CartTypes.SelfService">
          <th>{{ 'general.api_cart_table_type' | translate }}</th>
          <th>{{ 'general.api_cart_table_sector' | translate }}</th>
          <th>{{ 'general.api_cart_table_row' | translate }}</th>
          <th>{{ 'general.api_cart_table_seat' | translate }}</th>
        </ng-container>
        <th class="align-right min-width">{{ 'general.api_cart_table_quantity' | translate }}</th>
        <th class="align-right min-width">{{ 'general.api_cart_table_price' | translate }}</th>
        <th class="min-width">&nbsp;</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let event of service.ticketEventMap">
        <tr>
          <td *ngIf="collapsible">
            <button mat-button class="input-button icon-button small" (click)="toggleEventCollapse(event.id)" [disabled]="!event.quantity">
              <mat-icon class="svg-icon" [svgIcon]="isEventCollapsed(event.id) ? 'arrow_right' : 'arrow_down'"></mat-icon>
            </button>
          </td>
          <td class="align-center" *ngIf="canSelect">
            <mat-checkbox [checked]="isEventSelected(event.id)" [indeterminate]="isEventSelected(event.id, ChildSelectionState.SOME)"
                          (change)="toggleEvent($event, event.id)"></mat-checkbox>
          </td>
          <td [colSpan]="event.boEvent ? 3 : 7">
            <a class="link link-wrap bold" (click)="navigateToEventView.emit({eventId: event.id, rememberBooking: false})">
              <span>{{ event.title | translateValue }}</span>
            </a>
            <br>
            <small class="text-muted" *ngIf="event.venueTitle?.length">{{ event.venueTitle }}</small>
            <small class="text-muted" *ngIf="event.venueTitle?.length && event.onlineLocation?.length">&nbsp;/&nbsp;</small>
            <small class="text-muted" *ngIf="event.onlineLocation?.length">
              {{ (event.onlineLocation.length + (event.venueTitle?.length || 0)) > 50 ? ((event.onlineLocation | trim: (50 - (event.venueTitle?.length || 0))) + '...') : event.onlineLocation }}
            </small>
            <br><small class="text-muted white-space-no-wrap">{{ event.eventDate | period: {hasTimeInPeriod: true} }}</small>
          </td>
          <td *ngIf="hasAnyPromoCode">
            <mat-chip-listbox class="flex flex-end" *ngIf="event.promocode">
              <mat-chip-option [selectable]="false">
                {{ event.promocode }}
                <button matChipRemove (click)="removePromocode(event.id)" [disabled]="service.isLoading">
                  <mat-icon class="svg-icon" [svgIcon]="'close'"></mat-icon>
                </button>
              </mat-chip-option>
            </mat-chip-listbox>
          </td>
          <td class="white-space-no-wrap align-right medium">
            {{ event.quantity ? (event.quantity | quantityInPcs) : '-' }}
          </td>
          <td class="white-space-no-wrap align-right medium">
            {{ event.total | price }}
          </td>
          <td>
            <button mat-button class="input-button icon-button small" [matMenuTriggerFor]="eventMoreMenu">
              <mat-icon class="svg-icon" [svgIcon]="'menu_vert'"></mat-icon>
            </button>
            <mat-menu #eventMoreMenu="matMenu" [xPosition]="'before'">
              <button mat-menu-item (click)="openEventDetails(event.id)">
                <mat-icon class="svg-icon" [svgIcon]="'info'"></mat-icon>
                <span>{{'general.api_general_read_more' | translate}}</span>
              </button>
              <ng-container *ngIf="activeBookingMode">
                <button mat-menu-item (click)="navigateToEventView.emit({eventId: event.id, rememberBooking: activeBookingMode})">
                  <mat-icon class="svg-icon" [svgIcon]="'plus'"></mat-icon>
                  <span>{{'general.api_cart_add_tickets_to_same_event' | translate}}</span>
                </button>
                <button mat-menu-item (click)="navigateToEventView.emit({eventId: event.id, rememberBooking: false})">
                  <mat-icon class="svg-icon" [svgIcon]="'bookings'"></mat-icon>
                  <span>{{'general.api_cart_start_new_booking_same_event' | translate}}</span>
                </button>
              </ng-container>
              <button mat-menu-item (click)="removeEvent(event.id)">
                <mat-icon class="svg-icon" [svgIcon]="'trash'"></mat-icon>
                <span>{{'general.api_cart_table_event_remove' | translate}}</span>
              </button>
            </mat-menu>
          </td>
        </tr>
        <ng-container *ngIf="!isEventCollapsed(event.id)">
          <!-- PRICE ZONE -->
          <ng-container *ngIf="service.groupTicketsBy === GroupTickets.PriceZone">
            <ng-container *ngFor="let priceZone of event.legacyZones">
              <tr>
                <td [colSpan]="collapsible ? 2 : 1" class="align-right">
                  &nbsp;
                  <button mat-button class="input-button icon-button small" *ngIf="collapsible" (click)="togglePriceZoneCollapse(priceZone.id)">
                    <mat-icon class="svg-icon" [svgIcon]="isPriceZoneCollapsed(priceZone.id) ? 'arrow_right' : 'arrow_down'"></mat-icon>
                  </button>
                </td>
                <td class="align-center min-width" *ngIf="canSelect">
                  <mat-checkbox [checked]="isPriceZoneSelected(event.id, priceZone.typeId, priceZone.id)"
                                [indeterminate]="isPriceZoneSelected(event.id, priceZone.typeId, priceZone.id, ChildSelectionState.SOME)"
                                (change)="togglePriceZone($event, event.id, priceZone.typeId, priceZone.id)"></mat-checkbox>
                </td>
                <td [colSpan]="2" class="medium">
                  <div [ngClass]="{'short-text-cell': utilService.isScaledDown}">{{ 'general.api_sales_selected_price_zone' | translate }}</div>
                  <small class="text-muted">({{ priceZone.id }})</small>
                </td>
                <td class="medium">
                  <mat-form-field appearance="outline" class="small no-hint"
                                  *ngIf="canEdit && getAvailableTicketPrices(event, priceZone.tickets[0]).length > 1 && service.groupPriceTypeMap[priceZone.id + '_' + priceZone.typeId]">
                    <mat-select [(ngModel)]="service.groupPriceTypeMap[priceZone.id + '_' + priceZone.typeId]" [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="updatePriceTypesForGroup(event.id, service.groupPriceTypeMap[priceZone.id + '_' + priceZone.typeId], priceZone.tickets)">
                      <mat-option *ngFor="let priceType of getAvailableTicketPrices(event, priceZone.tickets[0])" [value]="priceType.id">
                        {{priceType.name | translate}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <ng-container *ngIf="!canEdit || getAvailableTicketPrices(event, priceZone.tickets[0]).length < 2">
                    {{ priceZone.typeName | translateValue }}
                  </ng-container>
                </td>
                <td [colSpan]="3">&nbsp;</td>
                <td class="medium align-right">{{ priceZone.quantity | quantityInPcs }}</td>
                <td class="white-space-no-wrap align-right">
                  <div class="flex flex-end">
                    <app-numeric-input *ngIf="canChangePrice && isPriceZoneSelected(event.id, priceZone.typeId, priceZone.id)"
                                       [type]="NumericInputType.Price" [small]="true" [withSuffix]="true" [changeDetector]="changeDetector"
                                       [(value)]="service.groupCustomPriceMap[priceZone.id + '_' + priceZone.typeId]"
                                       (inputKeyup)="utilService.isEnterKey($event) ? updateCustomPriceForGroup(event.id, service.groupCustomPriceMap[priceZone.id + '_' + priceZone.typeId], priceZone.tickets) : null">
                      <button mat-button class="input-button icon-button suffix-button small"
                              (click)="updateCustomPriceForGroup(event.id, service.groupCustomPriceMap[priceZone.id + '_' + priceZone.typeId], priceZone.tickets)">
                        <mat-icon class="svg-icon" [svgIcon]="'restart'"></mat-icon>
                      </button>
                    </app-numeric-input>
                  </div>
                </td>
                <td>&nbsp;</td>
              </tr>
              <ng-container *ngIf="!isPriceZoneCollapsed(priceZone.id)"
                            [ngTemplateOutlet]="legacyTicketsTemplate" [ngTemplateOutletContext]="{legacyTickets: priceZone.tickets}"></ng-container>
            </ng-container>
          </ng-container>
          <!-- PRICE ROW -->
          <ng-container *ngIf="service.groupTicketsBy === GroupTickets.Row">
            <ng-container *ngFor="let priceRow of event.legacyRows">
              <tr>
                <td [colSpan]="collapsible ? 2 : 1" class="align-right">
                  &nbsp;
                  <button mat-button class="input-button icon-button small" *ngIf="collapsible" (click)="togglePriceRowCollapse(priceRow.row)">
                    <mat-icon class="svg-icon" [svgIcon]="isPriceRowCollapsed(priceRow.row) ? 'arrow_right' : 'arrow_down'"></mat-icon>
                  </button>
                </td>
                <td class="align-center min-width" *ngIf="canSelect">
                  <mat-checkbox [checked]="isPriceRowSelected(event.id, priceRow.id, priceRow.row)"
                                [indeterminate]="isPriceRowSelected(event.id, priceRow.id, priceRow.row, ChildSelectionState.SOME)"
                                (change)="togglePriceRow($event, event.id, priceRow.id, priceRow.row)"></mat-checkbox>
                </td>
                <td [colSpan]="2" class="medium">
                  <div [ngClass]="{'short-text-cell': utilService.isScaledDown}">
                    {{ 'general.api_cart_table_row' | translate }}: {{ priceRow.row || ('general.api_cart_table_no_row' | translate) }}
                  </div>
                </td>
                <td class="medium">
                  <mat-form-field appearance="outline" class="small no-hint"
                                  *ngIf="canEdit && getAvailableTicketPrices(event, priceRow.tickets[0]).length > 1 && service.groupPriceTypeMap[priceRow.row + '_' + priceRow.id]">
                    <mat-select [(ngModel)]="service.groupPriceTypeMap[priceRow.row + '_' + priceRow.id]" [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="updatePriceTypesForGroup(event.id, service.groupPriceTypeMap[priceRow.row + '_' + priceRow.id], priceRow.tickets)">
                      <mat-option *ngFor="let priceType of getAvailableTicketPrices(event, priceRow.tickets[0])" [value]="priceType.id">
                        {{priceType.name | translate}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <ng-container *ngIf="!canEdit || getAvailableTicketPrices(event, priceRow.tickets[0]).length < 2">
                    {{ priceRow.name | translateValue }}
                  </ng-container>
                </td>
                <td [colSpan]="3">&nbsp;</td>
                <td class="medium align-right">{{ priceRow.quantity | quantityInPcs }}</td>
                <td class="white-space-no-wrap align-right">
                  <div class="flex flex-end">
                    <app-numeric-input *ngIf="canChangePrice && isPriceRowSelected(event.id, priceRow.id, priceRow.row)"
                                       [type]="NumericInputType.Price" [small]="true" [withSuffix]="true" [changeDetector]="changeDetector"
                                       [(value)]="service.groupCustomPriceMap[priceRow.row + '_' + priceRow.id]"
                                       (inputKeyup)="utilService.isEnterKey($event) ? updateCustomPriceForGroup(event.id, service.groupCustomPriceMap[priceRow.row + '_' + priceRow.id], priceRow.tickets) : null">
                      <button mat-button class="input-button icon-button suffix-button small"
                              (click)="updateCustomPriceForGroup(event.id, service.groupCustomPriceMap[priceRow.row + '_' + priceRow.id], priceRow.tickets)">
                        <mat-icon class="svg-icon" [svgIcon]="'restart'"></mat-icon>
                      </button>
                    </app-numeric-input>
                  </div>
                </td>
                <td>&nbsp;</td>
              </tr>
              <ng-container *ngIf="!isPriceRowCollapsed(priceRow.row)"
                            [ngTemplateOutlet]="legacyTicketsTemplate" [ngTemplateOutletContext]="{legacyTickets: priceRow.tickets}"></ng-container>
            </ng-container>
          </ng-container>
          <!-- PRICE TYPE -->
          <ng-container *ngIf="service.groupTicketsBy === GroupTickets.PriceType">
            <ng-container *ngFor="let priceType of event.legacyTypes">
              <tr>
                <td [colSpan]="collapsible ? 2 : 1" class="align-right">
                  &nbsp;
                  <button mat-button class="input-button icon-button small" *ngIf="collapsible" (click)="togglePriceTypeCollapse(priceType.id)">
                    <mat-icon class="svg-icon" [svgIcon]="isPriceTypeCollapsed(priceType.id) ? 'arrow_right' : 'arrow_down'"></mat-icon>
                  </button>
                </td>
                <td class="align-center min-width" *ngIf="canSelect">
                  <mat-checkbox [checked]="isPriceTypeSelected(event.id, priceType.id)"
                                [indeterminate]="isPriceTypeSelected(event.id, priceType.id, ChildSelectionState.SOME)"
                                (change)="togglePriceType($event, event.id, priceType.id)"></mat-checkbox>
                </td>
                <td [colSpan]="(!canEdit || getAvailableTicketPrices(event, priceType.tickets[0]).length < 2) ? 6 : 2" class="medium">{{ priceType.name | translateValue }}</td>
                <ng-container *ngIf="canEdit && getAvailableTicketPrices(event, priceType.tickets[0]).length > 1 && service.groupPriceTypeMap[priceType.id]">
                  <td>
                    <mat-form-field appearance="outline" class="small no-hint">
                      <mat-select [(ngModel)]="service.groupPriceTypeMap[priceType.id]" [ngModelOptions]="{standalone: true}"
                                  (ngModelChange)="updatePriceTypesForGroup(event.id, service.groupPriceTypeMap[priceType.id], priceType.tickets)">
                        <mat-option *ngFor="let priceType of getAvailableTicketPrices(event, priceType.tickets[0])" [value]="priceType.id">
                          {{priceType.name | translate}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </td>
                  <td [colSpan]="3">&nbsp;</td>
                </ng-container>
                <td class="medium align-right">{{ priceType.quantity | quantityInPcs }}</td>
                <td class="white-space-no-wrap align-right">
                  <div class="flex flex-end">
                    <app-numeric-input *ngIf="canChangePrice && isPriceTypeSelected(event.id, priceType.id)"
                                       [type]="NumericInputType.Price" [small]="true" [withSuffix]="true" [changeDetector]="changeDetector"
                                       [(value)]="service.groupCustomPriceMap[priceType.id]"
                                       (inputKeyup)="utilService.isEnterKey($event) ? updateCustomPriceForGroup(event.id, service.groupCustomPriceMap[priceType.id], priceType.tickets) : null">
                      <button mat-button class="input-button icon-button suffix-button small"
                              (click)="updateCustomPriceForGroup(event.id, service.groupCustomPriceMap[priceType.id], priceType.tickets)">
                        <mat-icon class="svg-icon" [svgIcon]="'restart'"></mat-icon>
                      </button>
                    </app-numeric-input>
                  </div>
                </td>
                <td>&nbsp;</td>
              </tr>
              <ng-container *ngIf="!isPriceTypeCollapsed(priceType.id)"
                            [ngTemplateOutlet]="legacyTicketsTemplate" [ngTemplateOutletContext]="{legacyTickets: priceType.tickets}"></ng-container>
            </ng-container>
          </ng-container>
          <!-- UNGROUPED -->
          <ng-container *ngIf="service.groupTicketsBy === GroupTickets.None"
                        [ngTemplateOutlet]="legacyTicketsTemplate" [ngTemplateOutletContext]="{legacyTickets: event.legacyTickets}"></ng-container>
        </ng-container>
        <ng-template #legacyTicketsTemplate let-legacyTickets="legacyTickets">
          <ng-container *ngFor="let ticket of legacyTickets">
            <tr *ngIf="!isBulkTicketRemoved(ticket.id)">
              <td [colSpan]="service.groupTicketsBy !== GroupTickets.None ? 2 : 1">&nbsp;</td>
              <td *ngIf="collapsible">&nbsp;</td>
              <td class="min-width align-center" *ngIf="canSelect">
                <mat-checkbox [checked]="isTicketSelected(ticket.id, event.id)"
                              (change)="toggleTicket($event, ticket.id, event.id, ticket.priceTypeId, ticket.priceClassId, ticket.row || 'none')"></mat-checkbox>
              </td>
              <td [colSpan]="service.groupTicketsBy === GroupTickets.None ? 2 : 1" class="bold white-space-no-wrap">
                {{ utilService.isScaledDown ? 'ID' : ('general.api_cart_table_ticket_id' | translate) }}: {{ ticket.id }}
              </td>
              <td class="break-word">
                <ng-container *ngIf="canEdit && isTicketSelected(ticket.id, event.id) && getAvailableTicketPrices(event, ticket).length > 1">
                  <mat-form-field appearance="outline" class="small no-hint">
                    <mat-select [(ngModel)]="ticket.priceTypeId" [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="service.updateTicketPriceType(event.id, ticket)">
                      <mat-option *ngFor="let priceType of getAvailableTicketPrices(event, ticket)" [value]="priceType.id">
                        {{priceType.name | translate}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ng-container>
                <ng-container *ngIf="!canEdit || !isTicketSelected(ticket.id, event.id) || getAvailableTicketPrices(event, ticket).length <= 1">
                  {{ ticket.priceTypeName | translate }}
                </ng-container>
              </td>
              <td>
                {{ (ticket.sectorName | translate) !== ticket.sectorName ? (ticket.sectorName | translate) : ticket.sectorId }}
              </td>
              <td>{{ ticket.row }}</td>
              <td>{{ ticket.place }}</td>
              <td>&nbsp;</td>
              <td class="white-space-no-wrap align-right">
                <div class="flex flex-end">
                  <ng-container *ngIf="hasGiftTicketReminderEnabled(event)">
                    <button mat-button class="input-button icon-button small right-spacer"
                            *ngIf="!ticketReminderEmailMap.get(ticket.id)"
                            (click)="openGiftTicketReminderModal(ticket)"
                            [matTooltip]="('general.api_cart_gift_ticket_reminder' | translate)">
                      <mat-icon class="svg-icon" [svgIcon]="'bell'"></mat-icon>
                    </button>
                    <button mat-flat-button color="primary" class="icon-button small right-spacer"
                            *ngIf="ticketReminderEmailMap.get(ticket.id)"
                            (click)="openGiftTicketReminderModal(ticket)"
                            [matTooltip]="ticketReminderEmailMap.get(ticket.id)">
                      <mat-icon class="svg-icon" [svgIcon]="'bell_notification'"></mat-icon>
                    </button>
                  </ng-container>
                  <app-numeric-input *ngIf="canChangeTicketPrice(event.id, ticket)" [type]="NumericInputType.Price"
                                     [small]="true" [withSuffix]="true" [changeDetector]="changeDetector"
                                     [(value)]="ticket.customPrice" (inputKeyup)="utilService.isEnterKey($event) ? service.updateTicketCustomPrice(event.id, ticket) : null">
                    <button mat-button class="input-button icon-button suffix-button small" (click)="service.updateTicketCustomPrice(event.id, ticket)">
                      <mat-icon class="svg-icon" [svgIcon]="'restart'"></mat-icon>
                    </button>
                  </app-numeric-input>
                  <ng-container *ngIf="!canChangeTicketPrice(event.id, ticket)">
                    <span>{{ ticket | ticketPrice: !excludeOwnFees || event.ownerSuperCentreId === authService.user.superCentreId }}</span>
                  </ng-container>
                </div>
              </td>
              <td class="min-width align-right">
                <button mat-button class="input-button icon-button small" *ngIf="canEdit" (click)="removeTicket(ticket.id)">
                  <mat-icon class="svg-icon" [svgIcon]="'trash'"></mat-icon>
                </button>
              </td>
            </tr>
          </ng-container>
        </ng-template>

        <ng-container *ngIf="!isEventCollapsed(event.id)">
          <ng-container *ngFor="let ticketType of event.unassignedTickets">
            <tr *ngIf="!isBulkTicketTypeRemoved(ticketType.ticketTypeUuid, event.id)">
              <td [colSpan]="3" *ngIf="collapsible">&nbsp;</td>
              <td class="min-width align-center" *ngIf="canSelect">
                <mat-checkbox [checked]="isTicketTypeSelected(ticketType.ticketTypeUuid, event.id)"
                              (change)="toggleTicketType($event, ticketType.ticketTypeUuid, event.id)"></mat-checkbox>
              </td>
              <td class="bold break-word" [colSpan]="!collapsible ? 3 : 1">
                {{ ticketType.name | translateValue }}
                <span class="medium"> - {{ ticketType.price | price }}</span>
              </td>
              <td *ngIf="hasAnyPromoCode">&nbsp;</td>
              <td class="white-space-no-wrap align-right medium">
                <app-add-remove [alignRight]="true" [count]="ticketTypeService.typeQuantities[ticketType.ticketTypeUuid]" [autoBind]="true"
                                [max]="getTicketTypeMax(ticketType.ticketTypeUuid, event.id)"
                                (countChange)="changeTicketTypeCount(ticketType.ticketTypeUuid, event.id, $event)"></app-add-remove>
              </td>
              <td class="white-space-no-wrap align-right medium">
                {{ (ticketType.price * ticketType.quantity) | price }}
              </td>
              <td>
                <button mat-button class="input-button icon-button small" *ngIf="canEdit"
                        (click)="removeTicketType(ticketType.ticketTypeUuid, event.id, ticketType.quantity)">
                  <mat-icon class="svg-icon" [svgIcon]="'trash'"></mat-icon>
                </button>
              </td>
            </tr>
          </ng-container>
        </ng-container>
      </ng-container>
    </tbody>
  </table>
  <div *ngIf="utilService.isMobile">
    <mat-card appearance="outlined" class="cart-table-mobile" *ngFor="let event of service.ticketEventMap">
      <div class="listing-block ticket-block-header">
        <div class="header-block flex space-between bottom-spacer">
          <div class="max-width flex">
            <mat-checkbox *ngIf="canSelect"
                          [checked]="isEventSelected(event.id)" [indeterminate]="isEventSelected(event.id, ChildSelectionState.SOME)"
                          (change)="toggleEvent($event, event.id)"></mat-checkbox>
            <div class="max-width">
              <div class="heading-5 no-margin link bold">
                <a (click)="navigateToEventView.emit({eventId: event.id, rememberBooking: false})">
                  {{ event.title | translateValue }}
                </a>
              </div>
              <small class="text-muted" *ngIf="event.venueTitle?.length">{{ event.venueTitle }}</small>
              <small class="text-muted" *ngIf="event.venueTitle?.length && event.onlineLocation?.length">&nbsp;/&nbsp;</small>
              <small class="text-muted" *ngIf="event.onlineLocation?.length">
                {{ (event.onlineLocation.length + (event.venueTitle?.length || 0)) > 70 ? ((event.onlineLocation | trim: (70 - (event.venueTitle?.length || 0))) + '...') : event.onlineLocation }}
              </small>
            </div>
          </div>
          <div class="white-space-no-wrap flex decreased-margin">
            <button mat-button class="input-button icon-button" [matMenuTriggerFor]="moreMenu">
              <mat-icon class="svg-icon" [svgIcon]="'menu_vert'"></mat-icon>
            </button>
            <mat-menu #moreMenu="matMenu" [xPosition]="'before'">
              <button mat-menu-item (click)="openEventDetails(event.id)">
                <mat-icon class="svg-icon" [svgIcon]="'info'"></mat-icon>
                <span>{{'general.api_general_read_more' | translate}}</span>
              </button>
              <ng-container *ngIf="activeBookingMode">
                <button mat-menu-item (click)="navigateToEventView.emit({eventId: event.id, rememberBooking: activeBookingMode})">
                  <mat-icon class="svg-icon" [svgIcon]="'plus'"></mat-icon>
                  <span>{{'general.api_cart_add_tickets_to_same_event' | translate}}</span>
                </button>
                <button mat-menu-item (click)="navigateToEventView.emit({eventId: event.id, rememberBooking: false})">
                  <mat-icon class="svg-icon" [svgIcon]="'bookings'"></mat-icon>
                  <span>{{'general.api_cart_start_new_booking_same_event' | translate}}</span>
                </button>
              </ng-container>
              <button mat-menu-item (click)="removeEvent(event.id)">
                <mat-icon class="svg-icon" [svgIcon]="'trash'"></mat-icon>
                <span>{{'general.api_cart_table_event_remove' | translate}}</span>
              </button>
            </mat-menu>
            <button mat-button class="input-button icon-button" (click)="toggleEventCollapse(event.id)" [disabled]="!event.quantity">
              <mat-icon class="svg-icon" [svgIcon]="isEventCollapsed(event.id) ? 'arrow_left' : 'arrow_down'"></mat-icon>
            </button>
          </div>
        </div>
        <div class="card-grid grid-2">
          <div class="grid-span" *ngIf="event.boEvent && event.promocode">
            <div class="heading-5 no-margin flex space-between max-width">
              <span class="medium">{{'general.api_cart_table_event_promocode' | translate}}:</span>
              <mat-chip-listbox>
                <mat-chip-option [selectable]="false">
                  {{ event.promocode }}
                  <button matChipRemove (click)="removePromocode(event.id)" [disabled]="service.isLoading">
                    <mat-icon class="svg-icon" [svgIcon]="'close'"></mat-icon>
                  </button>
                </mat-chip-option>
              </mat-chip-listbox>
            </div>
          </div>
          <div>
            <ng-container *ngIf="!event.isSeason">{{ event.eventDate | period: {hasTimeInPeriod: true} }}</ng-container>
          </div>
          <div class="flex flex-end primary-quantity bold">
            <div>{{ event.quantity ? (event.quantity | quantityInPcs) : '-' }}</div>
            <div>{{ event.total ? (event.total | price) : '-' }}</div>
          </div>
        </div>
      </div>

      <ng-container *ngIf="!isEventCollapsed(event.id)">
        <!-- PRICE ZONE -->
        <ng-container *ngIf="service.groupTicketsBy === GroupTickets.PriceZone">
          <ng-container *ngFor="let priceZone of event.legacyZones">
            <div class="listing-block ticket-block-sub-header">
              <div class="header-block flex space-between bottom-spacer">
                <div class="max-width flex flex-center">
                  <mat-checkbox *ngIf="canSelect"
                                [checked]="isPriceZoneSelected(event.id, priceZone.typeId, priceZone.id)"
                                [indeterminate]="isPriceZoneSelected(event.id, priceZone.typeId, priceZone.id, ChildSelectionState.SOME)"
                                (change)="togglePriceZone($event, event.id, priceZone.typeId, priceZone.id)"></mat-checkbox>
                  <div class="heading-5 no-margin medium">
                  <span class="bold break-word">
                    {{ 'general.api_sales_selected_price_zone' | translate }}
                    <small class="text-muted">({{ priceZone.id }})</small>
                  </span>
                    <br><small class="text-muted">{{ 'general.api_cart_table_type' | translate }}:&nbsp; {{ priceZone.typeName }}</small>
                  </div>
                </div>
                <div>
                  <button mat-button class="input-button icon-button" *ngIf="collapsible" (click)="togglePriceZoneCollapse(priceZone.id)">
                    <mat-icon class="svg-icon" [svgIcon]="isPriceZoneCollapsed(priceZone.id) ? 'arrow_left' : 'arrow_down'"></mat-icon>
                  </button>
                </div>
              </div>
              <div class="card-grid grid-2">
                <div class="white-space-no-wrap">
                  <mat-form-field appearance="outline" class="small no-hint"
                                  *ngIf="canEdit && getAvailableTicketPrices(event, priceZone.tickets[0]).length > 1 && service.groupPriceTypeMap[priceZone.id + '_' + priceZone.typeId]">
                    <mat-select [(ngModel)]="service.groupPriceTypeMap[priceZone.id + '_' + priceZone.typeId]" [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="updatePriceTypesForGroup(event.id, service.groupPriceTypeMap[priceZone.id + '_' + priceZone.typeId], priceZone.tickets)">
                      <mat-option *ngFor="let priceType of getAvailableTicketPrices(event, priceZone.tickets[0])" [value]="priceType.id">
                        {{priceType.name | translate}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="flex flex-end flex-center primary-quantity medium">
                  <div>{{ priceZone.quantity | quantityInPcs }}</div>
                  <div>
                    <app-numeric-input *ngIf="canChangePrice && isPriceZoneSelected(event.id, priceZone.typeId, priceZone.id)"
                                       [type]="NumericInputType.Price" [small]="true" [withSuffix]="true" [changeDetector]="changeDetector"
                                       [(value)]="service.groupCustomPriceMap[priceZone.id + '_' + priceZone.typeId]"
                                       (inputKeyup)="utilService.isEnterKey($event) ? updateCustomPriceForGroup(event.id, service.groupCustomPriceMap[priceZone.id + '_' + priceZone.typeId], priceZone.tickets) : null">
                      <button mat-button class="input-button icon-button suffix-button small"
                              (click)="updateCustomPriceForGroup(event.id, service.groupCustomPriceMap[priceZone.id + '_' + priceZone.typeId], priceZone.tickets)">
                        <mat-icon class="svg-icon" [svgIcon]="'restart'"></mat-icon>
                      </button>
                    </app-numeric-input>
                    <span class="medium" *ngIf="!canEdit || !authService.checkPrivileges(Privileges.TICKET_CUSTOM_PRICE)">
                      {{ priceZone.tickets[0] | ticketPrice: !excludeOwnFees || event.ownerSuperCentreId === authService.user.superCentreId }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="ticket-block" *ngIf="!isPriceZoneCollapsed(priceZone.id)">
              <ng-container [ngTemplateOutlet]="legacyTicketsMobileTemplate" [ngTemplateOutletContext]="{legacyTickets: priceZone.tickets}"></ng-container>
            </div>
          </ng-container>
        </ng-container>
        <!-- PRICE ROW -->
        <ng-container *ngIf="service.groupTicketsBy === GroupTickets.Row">
          <ng-container *ngFor="let priceRow of event.legacyRows">
            <div class="listing-block ticket-block-sub-header">
              <div class="header-block flex space-between bottom-spacer">
                <div class="max-width flex flex-center">
                  <mat-checkbox *ngIf="canSelect"
                                [checked]="isPriceRowSelected(event.id, priceRow.id, priceRow.row)"
                                [indeterminate]="isPriceRowSelected(event.id, priceRow.id, priceRow.row, ChildSelectionState.SOME)"
                                (change)="togglePriceRow($event, event.id, priceRow.id, priceRow.row)"></mat-checkbox>
                  <div class="heading-5 no-margin medium">
                  <span class="bold break-word">
                    {{ 'general.api_cart_table_row' | translate }}: {{ priceRow.row || ('general.api_cart_table_no_row' | translate) }}
                  </span>
                    <br><small class="text-muted">{{ 'general.api_cart_table_type' | translate }}:&nbsp; {{ priceRow.name }}</small>
                  </div>
                </div>
                <div>
                  <button mat-button class="input-button icon-button" *ngIf="collapsible" (click)="togglePriceRowCollapse(priceRow.row)">
                    <mat-icon class="svg-icon" [svgIcon]="isPriceRowCollapsed(priceRow.row) ? 'arrow_left' : 'arrow_down'"></mat-icon>
                  </button>
                </div>
              </div>
              <div class="card-grid grid-2">
                <div class="white-space-no-wrap">
                  <mat-form-field appearance="outline" class="small no-hint"
                                  *ngIf="canEdit && getAvailableTicketPrices(event, priceRow.tickets[0]).length > 1 && service.groupPriceTypeMap[priceRow.row + '_' + priceRow.id]">
                    <mat-select [(ngModel)]="service.groupPriceTypeMap[priceRow.row + '_' + priceRow.id]" [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="updatePriceTypesForGroup(event.id, service.groupPriceTypeMap[priceRow.row + '_' + priceRow.id], priceRow.tickets)">
                      <mat-option *ngFor="let priceType of getAvailableTicketPrices(event, priceRow.tickets[0])" [value]="priceType.id">
                        {{priceType.name | translate}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="flex flex-end flex-center primary-quantity medium">
                  <div>{{ priceRow.quantity | quantityInPcs }}</div>
                  <div>
                    <app-numeric-input *ngIf="canChangePrice && isPriceRowSelected(event.id, priceRow.id, priceRow.row)"
                                       [type]="NumericInputType.Price" [small]="true" [withSuffix]="true" [changeDetector]="changeDetector"
                                       [(value)]="service.groupCustomPriceMap[priceRow.row + '_' + priceRow.id]"
                                       (inputKeyup)="utilService.isEnterKey($event) ? updateCustomPriceForGroup(event.id, service.groupCustomPriceMap[priceRow.row + '_' + priceRow.id], priceRow.tickets) : null">
                      <button mat-button class="input-button icon-button suffix-button small"
                              (click)="updateCustomPriceForGroup(event.id, service.groupCustomPriceMap[priceRow.row + '_' + priceRow.id], priceRow.tickets)">
                        <mat-icon class="svg-icon" [svgIcon]="'restart'"></mat-icon>
                      </button>
                    </app-numeric-input>
                    <span class="medium" *ngIf="!canEdit || !authService.checkPrivileges(Privileges.TICKET_CUSTOM_PRICE)">
                      {{ priceRow.tickets[0] | ticketPrice: !excludeOwnFees || event.ownerSuperCentreId === authService.user.superCentreId }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="ticket-block" *ngIf="!isPriceRowCollapsed(priceRow.row)">
              <ng-container [ngTemplateOutlet]="legacyTicketsMobileTemplate" [ngTemplateOutletContext]="{legacyTickets: priceRow.tickets}"></ng-container>
            </div>
          </ng-container>
        </ng-container>
        <!-- PRICE TYPE -->
        <ng-container *ngIf="service.groupTicketsBy === GroupTickets.PriceType">
          <ng-container *ngFor="let priceType of event.legacyTypes">
            <div class="listing-block ticket-block-sub-header">
              <div class="header-block flex space-between bottom-spacer">
                <div class="max-width flex flex-center">
                  <mat-checkbox *ngIf="canSelect"
                                [checked]="isPriceTypeSelected(event.id, priceType.id)"
                                [indeterminate]="isPriceTypeSelected(event.id, priceType.id, ChildSelectionState.SOME)"
                                (change)="togglePriceType($event, event.id, priceType.id)"></mat-checkbox>
                  <div class="heading-5 no-margin bold break-word">{{ priceType.name | translateValue }}</div>
                </div>
                <div>
                  <button mat-button class="input-button icon-button" *ngIf="collapsible" (click)="togglePriceTypeCollapse(priceType.id)">
                    <mat-icon class="svg-icon" [svgIcon]="isPriceTypeCollapsed(priceType.id) ? 'arrow_left' : 'arrow_down'"></mat-icon>
                  </button>
                </div>
              </div>
              <div class="card-grid grid-2">
                <div class="white-space-no-wrap">
                  <mat-form-field appearance="outline" class="small no-hint"
                                  *ngIf="canEdit && getAvailableTicketPrices(event, priceType.tickets[0]).length > 1 && service.groupPriceTypeMap[priceType.id]">
                    <mat-select [(ngModel)]="service.groupPriceTypeMap[priceType.id]" [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="updatePriceTypesForGroup(event.id, service.groupPriceTypeMap[priceType.id], priceType.tickets)">
                      <mat-option *ngFor="let priceType of getAvailableTicketPrices(event, priceType.tickets[0])" [value]="priceType.id">
                        {{priceType.name | translate}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="flex flex-end flex-center primary-quantity medium">
                  <div>{{ priceType.quantity | quantityInPcs }}</div>
                  <div>
                    <app-numeric-input *ngIf="canChangePrice && isPriceTypeSelected(event.id, priceType.id)"
                                       [type]="NumericInputType.Price" [small]="true" [withSuffix]="true" [changeDetector]="changeDetector"
                                       [(value)]="service.groupCustomPriceMap[priceType.id]"
                                       (inputKeyup)="utilService.isEnterKey($event) ? updateCustomPriceForGroup(event.id, service.groupCustomPriceMap[priceType.id], priceType.tickets) : null">
                      <button mat-button class="input-button icon-button suffix-button small"
                              (click)="updateCustomPriceForGroup(event.id, service.groupCustomPriceMap[priceType.id], priceType.tickets)">
                        <mat-icon class="svg-icon" [svgIcon]="'restart'"></mat-icon>
                      </button>
                    </app-numeric-input>
                    <span class="medium" *ngIf="!canEdit || !authService.checkPrivileges(Privileges.TICKET_CUSTOM_PRICE)">
                      {{ priceType.tickets[0] | ticketPrice: !excludeOwnFees || event.ownerSuperCentreId === authService.user.superCentreId }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="ticket-block" *ngIf="!isPriceTypeCollapsed(priceType.id)">
              <ng-container [ngTemplateOutlet]="legacyTicketsMobileTemplate" [ngTemplateOutletContext]="{legacyTickets: priceType.tickets}"></ng-container>
            </div>
          </ng-container>
        </ng-container>
        <!-- UNGROUPED -->
        <ng-container *ngIf="service.groupTicketsBy === GroupTickets.None"
                      [ngTemplateOutlet]="legacyTicketsMobileTemplate" [ngTemplateOutletContext]="{legacyTickets: event.legacyTickets}"></ng-container>
      </ng-container>

      <ng-template #legacyTicketsMobileTemplate let-legacyTickets="legacyTickets">
        <ng-container *ngFor="let ticket of legacyTickets">
          <div class="listing-block" *ngIf="!isBulkTicketRemoved(ticket.id)">
            <div class="header-block flex space-between bottom-spacer">
              <div class="max-width flex flex-center">
                <mat-checkbox *ngIf="canSelect" [ngStyle]="{display: canSelect ? 'block' : 'none'}"
                              [checked]="isTicketSelected(ticket.id, event.id)"
                              (change)="toggleTicket($event, ticket.id, event.id, ticket.priceTypeId, ticket.priceClassId, ticket.row || 'none')"></mat-checkbox>
                <div class="heading-5 no-margin">
                  <span class="medium">{{'general.api_cart_table_ticket_id' | translate}}:</span> {{ticket.id}}
                </div>
              </div>
              <div class="white-space-no-wrap">
                <ng-container *ngIf="hasGiftTicketReminderEnabled(event)">
                  <button mat-button class="input-button icon-button small right-spacer"
                          *ngIf="!ticketReminderEmailMap.get(ticket.id)"
                          (click)="openGiftTicketReminderModal(ticket)"
                          [matTooltip]="('general.api_cart_gift_ticket_reminder' | translate)">
                    <mat-icon class="svg-icon" [svgIcon]="'bell'"></mat-icon>
                  </button>
                  <button mat-flat-button color="primary" class="icon-button small right-spacer"
                          *ngIf="ticketReminderEmailMap.get(ticket.id)"
                          (click)="openGiftTicketReminderModal(ticket)"
                          [matTooltip]="ticketReminderEmailMap.get(ticket.id)">
                    <mat-icon class="svg-icon" [svgIcon]="'bell_notification'"></mat-icon>
                  </button>
                </ng-container>
                <button mat-button class="input-button icon-button" *ngIf="canEdit" (click)="removeTicket(ticket.id)">
                  <mat-icon class="svg-icon" [svgIcon]="'trash'"></mat-icon>
                </button>
              </div>
            </div>
            <div class="card-grid grid-2">
              <div class="text-muted">
                {{ 'general.api_cart_table_sector' | translate }}:
                <span class="text-base">
                  {{ (ticket.sectorName | translate) !== ticket.sectorName ? (ticket.sectorName | translate) : ticket.sectorId }}
                </span>
              </div>
              <div class="flex flex-end">
                <div class="text-muted" *ngIf="ticket.row">
                  {{ 'general.api_cart_table_row' | translate }}: <span class="text-base medium">{{ ticket.row }}</span>
                </div>
                <div class="text-muted" *ngIf="ticket.place">
                  {{ 'general.api_cart_table_seat' | translate }}: <span class="text-base medium">{{ ticket.place }}</span>
                </div>
              </div>
            </div>
            <div class="card-grid grid-2">
              <div class="break-word">
                <mat-form-field appearance="outline" class="small no-hint"
                                *ngIf="canEdit && isTicketSelected(ticket.id, event.id) && getAvailableTicketPrices(event, ticket).length > 1">
                  <mat-select [(ngModel)]="ticket.priceTypeId" [ngModelOptions]="{standalone: true}"
                              (ngModelChange)="service.updateTicketPriceType(event.id, ticket)">
                    <mat-option *ngFor="let priceType of getAvailableTicketPrices(event, ticket)" [value]="priceType.id">
                      {{priceType.name | translate}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <ng-container *ngIf="!canEdit || !isTicketSelected(ticket.id, event.id) || getAvailableTicketPrices(event, ticket).length <= 1">
                  {{ ticket.priceTypeName | translate }}
                </ng-container>
              </div>
              <div class="primary-quantity flex flex-end flex-center">
                <app-numeric-input *ngIf="canChangeTicketPrice(event.id, ticket)"
                                   [type]="NumericInputType.Price" [small]="true" [withSuffix]="true" [changeDetector]="changeDetector"
                                   [(value)]="ticket.customPrice"
                                   (inputKeyup)="utilService.isEnterKey($event) ? service.updateTicketCustomPrice(event.id, ticket) : null">
                  <button mat-button class="input-button icon-button suffix-button small"
                          (click)="service.updateTicketCustomPrice(event.id, ticket)">
                    <mat-icon class="svg-icon" [svgIcon]="'restart'"></mat-icon>
                  </button>
                </app-numeric-input>
                <span *ngIf="!canChangeTicketPrice(event.id, ticket)">{{ ticket | ticketPrice: !excludeOwnFees || event.ownerSuperCentreId === authService.user.superCentreId }}</span>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-template>

      <ng-container *ngIf="!isEventCollapsed(event.id)">
        <ng-container *ngFor="let ticketType of event.unassignedTickets">
          <div class="listing-block" *ngIf="!isBulkTicketTypeRemoved(ticketType.ticketTypeUuid, event.id)">
            <div class="header-block flex space-between bottom-spacer">
              <div class="max-width flex flex-center">
                <mat-checkbox *ngIf="canSelect" [checked]="isTicketTypeSelected(ticketType.ticketTypeUuid, event.id)"
                              (change)="toggleTicketType($event, ticketType.ticketTypeUuid, event.id)"></mat-checkbox>
                <div class="heading-5 no-margin">
                  <span class="medium">{{'general.api_cart_table_type' | translate}}:</span> {{ ticketType.name | translateValue }}
                </div>
              </div>
              <div class="white-space-no-wrap">
                <button mat-button class="input-button icon-button" *ngIf="canEdit" (click)="removeTicketType(ticketType.ticketTypeUuid, event.id, ticketType.quantity)">
                  <mat-icon class="svg-icon" [svgIcon]="'trash'"></mat-icon>
                </button>
              </div>
            </div>
            <div class="card-grid grid-1-2">
              <div class="primary-quantity medium">{{ ticketType.price | price }}</div>
              <div class="primary-quantity flex flex-end flex-center semi-bold">
                <app-add-remove [alignRight]="true" [count]="ticketTypeService.typeQuantities[ticketType.ticketTypeUuid]" [autoBind]="true"
                                [max]="getTicketTypeMax(ticketType.ticketTypeUuid, event.id)"
                                (countChange)="changeTicketTypeCount(ticketType.ticketTypeUuid, event.id, $event)"></app-add-remove>
                <span>{{ (ticketType.price * ticketType.quantity) | price }}</span>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </mat-card>
  </div>
</ng-container>
